<app-ph-loader [show]="true" [fullscreen]="false" [static]="true"></app-ph-loader>
